export enum KnmSystemTypesEnum {
  ERP = 'ERP',
  ERKNM = 'ERKNM',
  PM = 'PM',
}
